import * as _ from "lodash";

/**
 * @description filters the source array by searching items which attributes defined in the attributes array match the filter param
 */
export default function filterBy(source: any[], filter: any, attributes: string[]){
  if (!filter)
    return source

  return source.filter(item => {
    let valid = false

    attributes.forEach(attribute =>{
      const value = _.get(item, attribute)?.toString()

      if (value?.toLowerCase().includes(filter.toString().toLowerCase())){
        valid = true
      }
    })

    return valid
  })
}
